// The person's settings' icons (Material Symbols, Outlined; filled while a page is open).
import devices from '@material-symbols/svg-400/outlined/devices.svg?raw';
import devicesFill from '@material-symbols/svg-400/outlined/devices-fill.svg?raw';
import download from '@material-symbols/svg-400/outlined/download.svg?raw';
import graphicEq from '@material-symbols/svg-400/outlined/graphic_eq.svg?raw';
import group from '@material-symbols/svg-400/outlined/group.svg?raw';
import history from '@material-symbols/svg-400/outlined/history.svg?raw';
import info from '@material-symbols/svg-400/outlined/info.svg?raw';
import infoFill from '@material-symbols/svg-400/outlined/info-fill.svg?raw';
import keyboard from '@material-symbols/svg-400/outlined/keyboard.svg?raw';
import keyboardFill from '@material-symbols/svg-400/outlined/keyboard-fill.svg?raw';
import language from '@material-symbols/svg-400/outlined/language.svg?raw';
import mail from '@material-symbols/svg-400/outlined/mail.svg?raw';
import link from '@material-symbols/svg-400/outlined/link.svg?raw';
import palette from '@material-symbols/svg-400/outlined/palette.svg?raw';
import paletteFill from '@material-symbols/svg-400/outlined/palette-fill.svg?raw';
import personAdd from '@material-symbols/svg-400/outlined/person_add.svg?raw';
import photo from '@material-symbols/svg-400/outlined/photo.svg?raw';
import schedule from '@material-symbols/svg-400/outlined/schedule.svg?raw';
import textFields from '@material-symbols/svg-400/outlined/text_fields.svg?raw';
import shield from '@material-symbols/svg-400/outlined/shield_person.svg?raw';
import tune from '@material-symbols/svg-400/outlined/tune.svg?raw';
import tuneFill from '@material-symbols/svg-400/outlined/tune-fill.svg?raw';
import visibilityOff from '@material-symbols/svg-400/outlined/visibility_off.svg?raw';
import warning from '@material-symbols/svg-400/outlined/warning.svg?raw';

export const settingsIcons = {
  devices, devicesFill, download, history, info, infoFill, keyboard, keyboardFill, language, link, palette, paletteFill,
  graphicEq, group, mail, shield, personAdd, photo, schedule, textFields, tune, tuneFill, visibilityOff, warning,
};
